import { render } from "./EzerFeedback.vue?vue&type=template&id=05e3de2b"
import script from "./EzerFeedback.vue?vue&type=script&lang=js"
export * from "./EzerFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__